import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import { MoneyFormate } from "../MoneyFormate";

type ListDataTableProp = {
    dataStr: object
    className?: string
    //customRow?: string[] // M => MoneyFormate;
}

type RowObject = {
    [key: string]: any;
}

const renderHeader = (_d: RowObject) => {
    const _th: string[] = []
    for (let key in _d) {
        const _k: string = key as string
        _th.push(_k as string)
    }
    return (
        <>
            {
                _th.map((val: string, index: number) =>
                    <th key={"th_" + index} >
                        {val}
                    </th>
                )
            }
        </>
    )
}
export default (props: ListDataTableProp) => {
    const renderRow = (_d: RowObject) => {
        const _td: string[] = []
        //console.log(props)
        for (let key in _d) {
            _td.push(_d[key] as string)
        }
        
        return (
            <>
                {
                    _td.map((val: string, index: number) =>
                        <td key={"td_" + index}>
                            {/*
                                props.customRow && props.customRow.length > 0 && props.customRow[index] == "M"?
                                MoneyFormate(parseFloat(val)):
                                val
                            */}
                            {val}
                        </td>
                    )
                }
            </>
        )
    }

    const d: RowObject[] = props.dataStr as RowObject[]
    
    return (
        <table className={"hibTable " + (props.className ? props.className : "")} style={{ width: "100%" }}>
            <thead>
                <tr>
                    {
                        renderHeader(d[0])
                    }
                </tr>
            </thead>
            <tbody>
                {
                    
                    d.map((obj: RowObject, index: number) => {
                        return (
                            <tr key={"tr_" + index}>{renderRow(obj)}</tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
};
